import {
  FETCH_VERIFY_THERMIT_LOGIN_REQUEST,
  FETCH_VERIFY_THERMIT_LOGIN_SUCCESS,
  FETCH_VERIFY_THERMIT_LOGIN_FALUIRE,
  FETCH_CLEAR_ERROR_MESSAGE
  
} from './verifyThermitLoginTypes'

const initialState = {
  loading: false,
  verifyThermitLoginInformation: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VERIFY_THERMIT_LOGIN_REQUEST: return {
      ...state,
      loading: true,

    }

    case FETCH_VERIFY_THERMIT_LOGIN_SUCCESS: return {
      ...state,
      verifyThermitLoginInformation: action.payload,
      error: '',
      loading: false,
    }
    case   FETCH_CLEAR_ERROR_MESSAGE
    : return {
      ...state,
      error: '',
      loading: false,
    }
  
    case FETCH_VERIFY_THERMIT_LOGIN_FALUIRE: return {
      ...state,
      loading: false,
      verifyThermitLoginInformation: null,
      error: action.payload,
    }
    default: return state
  }
}

export default reducer
